/**
 * HTTP layer for relay-controller status records. A device's reported status
 * history.
 *
 * Contains:
 * - fetchStatuses: a relay controller's status list
 * - fetchStatus: one status record
 */
import apiClient from '@sophocles/http-common';

export const fetchStatuses = (relayControllerId, queryParams) =>
  apiClient.get(`/relaycontrollers/${relayControllerId}/statuses/`, { params: queryParams }).then(res => res.data);

export const fetchStatus = (relayControllerId, statusId) =>
  apiClient.get(`/relaycontrollers/${relayControllerId}/statuses/${statusId}/`).then(res => res.data);
